import { useLocale } from "../../hooks/useLocale";
import { msg } from "../../locales/translate";
import { VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import { Error } from "@ui/error/Error";
import Input from "@ui/input/Input";
import Panel from "@ui/panel/Panel";
import Signal from "badmfck-signal";
import { useEffect, useState } from "react";
import { GD } from "src/GD";
import { MerchantGroupSelector } from "../pages/balancerPage/components/MerchantGroupSelector";
import { MerchantTerminalSelector } from "../pages/balancerPage/components/MerchantTerminalSelector";

export const S_ADD_MERCHANT_CHANNEL_POPUP = new Signal<{
	id: number;
	client_id: number;
	group_id?: number;
	onSuccess?: () => void;
} | null>("S_ADD_MERCHANT_POPUP");

export const AddMerchantChannelPopup = () => {
	useLocale();
	const requestData = S_ADD_MERCHANT_CHANNEL_POPUP.use();
	const [busy, setBusy] = useState<boolean>();
	const [error, setError] = useState<IError>();
	const [merchant, setMerchant] = useState<IMerchantModel>();

	useEffect(() => {
		if (requestData) {
			loadMerchant();
		}
	}, [requestData]);

	const loadMerchant = async () => {
		if (requestData) {
			const res = await GD.REQ_MERCHANT.request({
				merchantID: requestData.id,
				clientID: requestData.client_id,
				groupID: requestData.group_id,
			});

			if (res?.error) {
				setError(res?.error);
			} else if (res?.data) {
				setMerchant({ ...res.data });
			}
		}
	};

	if (!requestData) return null;

	const handleSubmit = async () => {
		if (merchant) {
			setError(undefined);
			setBusy(true);
			const res = await GD.REQ_MERCHANT_SAVE.request(merchant);
			if (!res.error) {
				requestData.onSuccess && requestData.onSuccess();
				closePopup();
			} else {
				setError(res.error);
			}
			setBusy(false);
		}
	};

	const closePopup = () => {
		S_ADD_MERCHANT_CHANNEL_POPUP.invoke(null);
		setError(undefined);
		setMerchant(undefined);
	};

	return (
		<Panel
			sx={{
				maxWidth: "1200px",
				height: "80vh",
				padding: "0",
				minWidth: "500px",
			}}
			decorator="absolute"
			busy={busy}
			label={requestData.id === 0 ? msg("addNewChannel") : msg("editChannel_206f3dd8")}
			onClose={closePopup}>
			<VBox
				gap="20px"
				sx={{
					overflow: "auto",
					flexGrow: 1,
					padding: "20px 20px",
					backgroundColor: "#EEF0F2",
				}}>
				{merchant && <MerchantGroupSelector merchant={merchant} clientID={requestData.client_id} />}
				{merchant && <MerchantTerminalSelector merchant={merchant} />}

				{merchant && <Input type="text" label={msg("name")} name="name" data={merchant as unknown as { [key: string]: string }} />}

				{merchant && <Input type="text" label={msg("description")} name="description" data={merchant as unknown as { [key: string]: string }} />}
			</VBox>

			<VBox sx={{ padding: "20px", gap: "12px" }}>
				<Error error={error} />
				<Button
					title={msg("saveMerchant")}
					onClick={() => {
						handleSubmit();
					}}
				/>
			</VBox>
		</Panel>
	);
};
